import React, { useState } from "react";
import { vendor_page_labels } from "../../../Constants/Labels";
import RichTextEditor from "../../Global/RichTextEditor/RichTextEditor";
import "./TextAndVideoBlock.css";

const TextAndVideoBlock = ({
  data,
  id,
  onRemove,
  textAndVideoBlock,
  onChangeTextAndVideoBlockField,
  onChangeTextAndVideoBlockDescription,
  config,
}) => {
  const [localDescription, setLocalDescription] = useState(
    textAndVideoBlock?.left_content?.description || "",
  );
  const [isUserEditing, setIsUserEditing] = useState(false);

  const handleDescriptionChange = (name, value) => {
    setIsUserEditing(true);
    if (value !== localDescription) {
      setLocalDescription(value);
      onChangeTextAndVideoBlockDescription(value);
    }
  };

  const getEmbedUrl = (url) => {
    if (!url) return "";
    let embedUrl = url;

    // YouTube
    const ytMatch = url.match(
      /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})/,
    );
    if (ytMatch && ytMatch[1]) {
      embedUrl = `https://www.youtube.com/embed/${ytMatch[1]}`;
    }

    // Vimeo
    const vimeoMatch = url.match(/(?:vimeo\.com\/)(\d+)/);
    if (vimeoMatch && vimeoMatch[1]) {
      embedUrl = `https://player.vimeo.com/video/${vimeoMatch[1]}`;
    }

    return embedUrl;
  };

  return (
    <div className="block-container">
      <div className="block-header">
        <h5 className="block-title">Text and Video Block</h5>
        <div className="block-actions">
          <button className="block-action-btn remove" onClick={onRemove}>
            <span className="mdi mdi-delete"></span> Remove
          </button>
        </div>
      </div>
      <div className="block-content">
        <div className="">
          <div className="card-body">
            <div className="col-12 row">
              <div className="col-6">
                <h6 className="mb-3">Left Content</h6>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-label">Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      name="heading"
                      value={
                        textAndVideoBlock?.["heading"] ||
                        textAndVideoBlock?.left_content?.["heading"] ||
                        ""
                      }
                      onChange={(e) =>
                        onChangeTextAndVideoBlockField(e, "left_content")
                      }
                    />
                  </div>
                </div>
                <div className="col-12 mb-4">
                  <div className="form-group mb-2 page_2_portrait">
                    <label className="form-label">Description</label>
                    <RichTextEditor
                      name="description"
                      onChange={handleDescriptionChange}
                      value={localDescription}
                    />
                  </div>
                </div>
                <div className="col-lg-12 row">
                  <div className="form-group col-lg-6">
                    <label className="form-label">Primary Button Label</label>
                    <input
                      type="text"
                      className="form-control"
                      name="primary_button_label"
                      value={
                        textAndVideoBlock?.["primary_button_label"] ||
                        textAndVideoBlock?.left_content?.[
                          "primary_button_label"
                        ] ||
                        ""
                      }
                      onChange={(e) =>
                        onChangeTextAndVideoBlockField(e, "left_content")
                      }
                    />
                  </div>
                  <div className="form-group col-lg-6">
                    <label className="form-label">Primary Button URL</label>
                    <input
                      type="text"
                      className="form-control"
                      name="primary_button_url"
                      value={
                        textAndVideoBlock?.["primary_button_url"] ||
                        textAndVideoBlock?.left_content?.[
                          "primary_button_url"
                        ] ||
                        ""
                      }
                      onChange={(e) =>
                        onChangeTextAndVideoBlockField(e, "left_content")
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-12 row">
                  <div className="form-group col-lg-6">
                    <label className="form-label">Secondary Button Label</label>
                    <input
                      type="text"
                      className="form-control"
                      name="secondary_button_label"
                      value={
                        textAndVideoBlock?.["secondary_button_label"] ||
                        textAndVideoBlock?.left_content?.[
                          "secondary_button_label"
                        ] ||
                        ""
                      }
                      onChange={(e) =>
                        onChangeTextAndVideoBlockField(e, "left_content")
                      }
                    />
                  </div>
                  <div className="form-group col-lg-6">
                    <label className="form-label">Secondary Button URL</label>
                    <input
                      type="text"
                      className="form-control"
                      name="secondary_button_url"
                      value={
                        textAndVideoBlock?.["secondary_button_url"] ||
                        textAndVideoBlock?.left_content?.[
                          "secondary_button_url"
                        ] ||
                        ""
                      }
                      onChange={(e) =>
                        onChangeTextAndVideoBlockField(e, "left_content")
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="col-6">
                <h6 className="mb-3">Right Content</h6>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-label">Video URL</label>
                    <input
                      type="text"
                      className="form-control"
                      name="video_url"
                      value={
                        textAndVideoBlock?.right_content?.["video_url"] || ""
                      }
                      onChange={(e) =>
                        onChangeTextAndVideoBlockField(e, "right_content")
                      }
                      placeholder="Enter Video URL"
                    />
                  </div>
                </div>
                <div className="col-12 mt-3 text-center">
                  {textAndVideoBlock?.right_content?.["video_url"] ? (
                    <div className="video-preview w-100">
                      <iframe
                        width="100%"
                        height="250"
                        src={
                          textAndVideoBlock?.right_content?.["embed_url"] ||
                          getEmbedUrl(
                            textAndVideoBlock?.right_content?.["video_url"],
                          )
                        }
                        title="Video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  ) : (
                    <div className="video-preview-placeholder">
                      <span
                        className="mdi mdi-video-off-outline"
                        style={{ fontSize: "48px", color: "#dee2e6" }}
                      ></span>
                      <p className="mt-2 text-muted">No video url provided</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextAndVideoBlock;
